export const notificationTypeData = [
  {
    label: "General",
    value: "General",
    tooltipContent: "General: Regular message or announcement",
  },
  {
    label: "Alert",
    value: "Alert",
    tooltipContent: "Alert: Urgent message requiring action",
  },
];
